var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGcp = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 17,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M6.667 5.924A4 4 0 0 0 5 5.56c-.984 0-1.934.362-2.667 1.019M8 10.894v2.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M2.845 6.19A4 4 0 0 0 5 13.56h6a4 4 0 0 0 2.155-7.37 5.335 5.335 0 0 0-10.31 0ZM6.08 5.71A4 4 0 0 1 8.464 7.56L6.156 8.894a1.332 1.332 0 0 0-2.464.912A1.335 1.335 0 0 0 5 10.894h6a1.334 1.334 0 0 0 .485-2.576l-.742-.29-.096-.792a2.667 2.667 0 0 0-4.566-1.527ZM2.667 12.81l1.966-1.967M11.729 3.748 9.843 5.634"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 17,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinejoin: "round",
    d: "M6.667 5.924A4 4 0 0 0 5 5.56c-.984 0-1.934.362-2.667 1.019M8 10.894v2.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinejoin: "round",
    d: "M2.845 6.19A4 4 0 0 0 5 13.56h6a4 4 0 0 0 2.155-7.37 5.335 5.335 0 0 0-10.31 0ZM6.08 5.71A4 4 0 0 1 8.464 7.56L6.156 8.894a1.332 1.332 0 0 0-2.464.912A1.335 1.335 0 0 0 5 10.894h6a1.334 1.334 0 0 0 .485-2.576l-.742-.29-.096-.792a2.667 2.667 0 0 0-4.566-1.527ZM2.667 12.81l1.966-1.967M11.729 3.748 9.843 5.634"
  }));
});
export default SvgIconGcp;
export const raw = __webpack_public_path__ + "static/media/IconGCP.46765c55d4b3ec44dfec2f91cc7cff91.svg";